<template>
    <section class="disallowed box-shadow--big">
        <img src="../../../assets/images/icons/ico-not-ok.png" />
        <h3 class="disallowed__header">{{ $t('YOU_CAN_NOT_DO_BRASTER') }} <br />{{ $t('UNTIL_LACTATION_ENDS') }}</h3>
        <p>
            {{ $t('IF_YOU_BOUGHT_PACKAGE')
            }}<a href="#" @click="linkClicked(eSklepUrl + $t('LINK_CONTACT_MODAL'))">{{ $t('CONTACT_WITH_US') }}</a>
            <br />
            {{ $t('EXTEND_EXPIRATION_DATE_PREGNANCY') }}
        </p>

        <a class="font-small" href="#" @click="linkClicked(eSklepUrl + $t('LINK_WARNINGS'))"
            >{{ $t('GET_TO_KNOW_WARNINGS') }} <img style="width: 14px" src="../../../assets/images/arrow-red.png" />
        </a>
        <br />
        <button @click.stop="closeModal()" class="w160 app-btn app-btn-primary mt-3">
            {{ $t('CLOSE_WINDOW') }}
        </button>
    </section>
</template>

<script>
import { config, linkClicked } from './../../../main';

export default {
    name: 'survey-disallowed-by-pregnant',
    data() {
        return {
            eSklepUrl: config.eSklepUrl,
        };
    },
    methods: {
        linkClicked(link) {
            linkClicked(link);
        },
        closeModal() {
            //deny permission to use Braster
            this.$store.dispatch('setBrasterPermission', {
                brasterAllowed: false,
            });

            //close modal emiting
            this.$emit('close');
        },
    },
};
</script>



// WEBPACK FOOTER //
// survey-disallowed-by-pregnant.vue?03e506b6